/**
 * Origine d'une demande de contact — implémentation UNIQUE (liste + modale).
 *
 * Deux portes d'entrée écrivent dans `contacts_agence` :
 *   - la fiche publique d'un bien   (`POST /public/fiche/{token}/contact`) → `fiche_publique`
 *   - une collection de biens partagée (`POST /contact-agence`)           → `collection_partagee`
 *
 * Le site vitrine WordPress n'est PAS une porte d'entrée : son bouton « Consulter le dossier
 * complet » renvoie vers la fiche publique du CRM, donc ses demandes arrivent — à juste
 * titre — avec `fiche_publique`. Rien ne permet de les distinguer (tranché le 2026-06-06).
 *
 * Les demandes antérieures n'ont pas de `source` : elles viennent du second chemin, seul à
 * ne pas l'écrire.
 */
export const getDemandeOrigine = (demande) =>
  (demande?.source === 'fiche_publique' ? 'Fiche publique' : 'Collection partagée');
